import React, { useEffect } from "react";
import { Button, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useBillModel } from "./billModel";
import { IBillDetail } from "../../../../../bill/BillTypes";
import { useDetailModel } from "../detailModel";
import { billStatusRender, ioFlagRender } from "@/types/FmsRender";
import { TradeTypeEnum } from "@/types/FmsEnums";
import BillDetailRender from "@/views/vrmBill";
import YhTootip from "@/components/YhTootip";
import { billDetailRenderModel } from "@/views/vrmBill/bIllDetailRenderModel";



export function BillDataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loadData,
        selectedData,
        setSelectedRowKeys,
        setSelectedData,
        resendMsg,
    } = useBillModel();

    const {
        payMethodLabels,
    } = useDetailModel()
    const { goToBill } = billDetailRenderModel();

    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            // width: 60,
            // ellipsis: true,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            title: '单据编号',
            dataIndex: 'tradeCode',
            // render: (t, r) => BillDetailRender(t, r)
            render: (text, recode) => <YhTootip text={text} onClick={() => goToBill(text, recode)} />
        },
        {
            align: "center",
            title: '客户名称',
            dataIndex: 'partnerName',
        },
        {
            align: "center",
            title: '单据金额',
            dataIndex: 'billAmount',
            render: (text, record) => (
                record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
                record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
                record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            align: "center",
            title: '支付类型',
            dataIndex: 'payType',
            render: v => payMethodLabels[v] ?? '暂无'
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
        {
            align: "center",
            // width: 100,
            // ellipsis: true,
            title: '账户类型',
            dataIndex: 'accountTypeName',
        },
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
        },

        {
            align: "center",
            title: '单据类型',
            dataIndex: 'tradeTypeName',
        },
        {
            align: "center",
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            render: v => v ?? '暂无'
        },
        {
            align: "center",
            title: '账单编码',
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
        },
        {
            align: "center",
            title: '实体',
            dataIndex: 'beName',
        },
        {
            align: "center",
            title: '收支类型',
            dataIndex: 'ioFlag',
            render: ioFlagRender
        },
        {
            align: "center",
            title: '收款状态',
            dataIndex: 'status',
            render: billStatusRender
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
        },
        {
            align: "center",
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'tradeOperator',
        },
        {
            align: "center",
            title: '核销日期',
            dataIndex: 'writeoffTime',
        },
        {
            align: "center",
            title: '核销人',
            dataIndex: 'writeoffUser',
        },
        {
            align: "center",
            title: '取消状态',
            dataIndex: 'cancelStatus',
            render: (v) => v === 0 ? '初始' : v === 1 ? '审核中' : v === 2 ? '已取消' : v === 9 ? '异常 ' : ''
        },
        {
            align: "center",
            title: '操作',
            dataIndex: 'status',
            fixed: 'right',
            render: (v,r) => v === 2 ? <Button type="link" shape="round" size="small" onClick={() => resendMsg(r?.code as string)}>重发</Button> : ''
        },
    ];


    return (
        <Table
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setSelectedData(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.findIndex(item => item === record.key) !== -1) {
                            setSelectedRowKeys(arr => arr.filter(item => item !== record.key));
                            setSelectedData(arr => arr.filter(item => item.key !== record.key))
                        } else {
                            setSelectedRowKeys([...selectedRowKeys, record.key]);
                            setSelectedData([...selectedData, record])
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
